import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const KEY = "eazikast-cookie-consent";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const decide = (choice) => {
    try {
      localStorage.setItem(KEY, choice);
    } catch {
      /* ignore storage errors */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-md z-[60] bg-[#16181A]/95 backdrop-blur-xl border border-[#2E3033] shadow-[0_4px_40px_rgba(0,0,0,0.6)] rounded-lg p-5 animate-in slide-in-from-bottom-4 fade-in duration-300"
    >
      <button
        data-testid="cookie-consent-close"
        onClick={() => decide("dismissed")}
        aria-label="Dismiss"
        className="absolute top-3 right-3 text-[#6E7787] hover:text-white transition-colors"
      >
        <X className="h-4 w-4" />
      </button>
      <div className="flex items-start gap-3">
        <div className="mt-0.5 shrink-0 h-9 w-9 rounded-md bg-[#2560C9]/15 border border-[#2560C9]/30 flex items-center justify-center">
          <Cookie className="h-4 w-4 text-[#3B75DF]" />
        </div>
        <div className="min-w-0">
          <p className="font-heading text-sm font-bold text-white tracking-tight">Cookies &amp; local storage</p>
          <p className="text-[12px] text-[#A0AABF] leading-relaxed mt-1">
            We use a secure sign-in cookie and your browser's local storage to keep you logged in and
            enable offline yard planning. See our{" "}
            <Link to="/privacy" className="text-[#3B75DF] hover:text-white underline">Privacy Policy</Link>.
          </p>
          <div className="flex items-center gap-2 mt-4">
            <button
              data-testid="cookie-consent-accept"
              onClick={() => decide("accepted")}
              className="bg-[#2560C9] hover:bg-[#3B75DF] text-white text-[12px] font-medium px-4 py-2 rounded-md transition-colors"
            >
              Got it
            </button>
            <Link
              to="/privacy"
              data-testid="cookie-consent-learn-more"
              className="text-[12px] font-mono uppercase tracking-[0.12em] text-[#6E7787] hover:text-white transition-colors px-2 py-2"
            >
              Learn more
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
